import { useState } from 'react';
import type { QuizItem } from '../types';

function Question({ item, number }: { item: QuizItem; number: number }) {
  const [selected, setSelected] = useState<number | null>(null);
  return <div className="quiz-question">
    <h4><span>{number}</span>{item.question}</h4>
    <div className="quiz-options">{item.options.map((option, index) => <button type="button" key={option} onClick={() => setSelected(index)} className={selected === index ? (index === item.answer ? 'correct' : 'wrong') : ''} aria-pressed={selected === index}>{String.fromCharCode(65 + index)}. {option}</button>)}</div>
    {selected !== null && <div className={`quiz-feedback ${selected === item.answer ? 'correct' : 'wrong'}`} role="status"><strong>{selected === item.answer ? '回答正确' : `再想想，正确答案是 ${String.fromCharCode(65 + item.answer)}`}</strong><span>{item.explanation}</span></div>}
  </div>;
}

export function Quiz({ items }: { items: QuizItem[] }) {
  return <div className="quiz-card">{items.map((item, index) => <Question key={item.question} item={item} number={index + 1} />)}</div>;
}
